import { clearTimeouts, engine as anime } from "../index";

const timeouts = [];

const main = (props) => {
  const timeouts = [];
  const { id, format } = props;

  const timeline = anime.timeline();

  $(`#${id} .team-logo-container img`).css("opacity", 0);
  $(`#${id} .headline`).css("opacity", 0);
  // $(`#${id} .last-x-games`).css("opacity", 0);
  // $(`#${id} .team-stats .value `).css("opacity", 0);
  $(`#${id} .team-stats .label `).css("opacity", 0);

  $(`#${id} .team-block-line`).css("opacity", 0);
  $(`#${id} .filler-point-base, #${id} .filler-container`).css("opacity", 0);
  $(`#${id} .filler-container`).css("width", 0);
  $(`#${id} .stroke-shadow, .stroke-shadow-2`).css("opacity", 0);
  $(
    `#${id} .line-stats-container .value, #${id} .line-stats-container .box-bg`,
  ).css("opacity", 0);

  anime({
    targets: [`#${id} .team-logo-container img`],
    duration: 400,
    easing: "easeOutQuint",
    opacity: [1, 1],
    scale: [0, 1],
    delay: 1600,
  });

  anime
    .timeline({
      targets: `#${id} .headline`,
      easing: "easeInOutQuint",
      delay: 100,
    })
    .add({
      scale: [0, 1.5],
      duration: 900,
      opacity: [1, 1],
    })
    .add({
      scale: [1.5, 1.0],
      top: [400, $(`#${id} .headline`).css("top")],
      duration: 600,
      delay: 100,
      opacity: [1, 1],
    });

  anime({
    targets: [`#${id} .subline`],
    duration: 400,
    easing: "easeOutQuint",
    opacity: [1, 1],
    scale: [0, 1],
    delay: 1600,
  });

  anime({
    targets: $(
      `#${id} .last-x-games > div`,
    ).toArray(),
    duration: 600,
    easing: "easeInOutQuart",
    opacity: [0, 1],
    delay: anime.stagger(150, { start: 1400 }),
  });

  // anime({
  //   targets: $(
  //     `#${id} .last-games-container > div`,
  //   ).toArray(),
  //   duration: 300,
  //   easing: "easeInOutQuart",
  //   opacity: [0, 1],
  //   delay: anime.stagger(150, { start: 1700 }),
  // });

  anime({
    targets: `#${id} .team-block-line`,
    keyframes: [
      { clipPath: "inset(100% 0 0 0)", duration: 0 },
      { clipPath: "inset(0% 0 0 0)", duration: 800 },
    ],
    easing: "easeInOutQuart",
    opacity: [1, 1],
    delay: 1600, // 200ms delay between each elemen
  });

  anime
    .timeline({
      targets: `#${id} .team-stats .value`,
      easing: "easeInOutQuint",
      delay: anime.stagger(150, { start: 2200 }), // 200ms delay between each elemen
    })
    .add({
      scale: [0, 1],
      duration: 300,
      opacity: [0, 1],
    });

  anime({
    targets: `#${id} .team-stats-block .label`,
    keyframes: [
      { clipPath: "inset(100% 0 0 0)", duration: 0 },
      { clipPath: "inset(0% 0 0 0)", duration: 300 },
    ],
    easing: "easeInOutQuart",
    opacity: [1, 1],
    delay: anime.stagger(150, { start: 2000 }), // 200ms delay between each elemen
  });

  anime({
    targets: `#${id} .team-stats-block .value`,
    keyframes: [
      { clipPath: "inset(100% 0 0 0)", duration: 0 },
      { clipPath: "inset(0% 0 0 0)", duration: 300 },
    ],
    easing: "easeInOutQuart",
    opacity: [1, 1],
    delay: anime.stagger(150, { start: 2000 }), // 200ms delay between each elemen
  });

  anime({
    targets: `#${id} .team-stats-block .container`,
    keyframes: [
      { clipPath: "inset(100% 0 0 0)", duration: 0 },
      { clipPath: "inset(0% 0 0 0)", duration: 300 },
    ],
    easing: "easeInOutQuart",
    opacity: [1, 1],
    delay: anime.stagger(150, { start: 2000 }), // 200ms delay between each elemen
  });

  const timeout3 = setTimeout(() => {
    anime({
      targets: [`#${id} .filler-container`],
      duration: 1000,
      easing: "easeOutQuint",
      opacity: [1, 1],
      width: [0, 650],
      // translateY: [1000, 0],
      delay: anime.stagger(120),
    });
  }, 1500);

  timeouts.push(timeout3);

  return {
    timeline: timeline,
    timeouts: timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
